import React from "react";
import PageShell from "@/components/PageShell";

const Section = ({ title, children, testid }) => (
  <section data-testid={testid} className="mt-12 first:mt-0">
    <h2 className="font-display text-2xl lg:text-3xl font-light text-[#E6D5B8] mb-5">
      {title}
    </h2>
    <div className="text-[15px] lg:text-base text-[#F9F6F0]/75 font-light leading-relaxed space-y-4">
      {children}
    </div>
  </section>
);

const Privacidad = () => {
  return (
    <PageShell testid="privacy-page">
      <article className="max-w-3xl mx-auto px-6 lg:px-10 pt-12 pb-16">
        <div className="flex items-center gap-3 mb-6">
          <span className="h-px w-10 bg-[#E6D5B8]" />
          <span className="text-[11px] tracking-luxury uppercase text-[#E6D5B8] font-medium">
            LFPDPPP · México
          </span>
        </div>
        <h1 className="font-display text-4xl sm:text-5xl font-light leading-[1.05]">
          Aviso de{" "}
          <span className="italic text-[#E6D5B8]">Privacidad Integral</span>
        </h1>
        <p className="mt-5 text-sm text-[#F9F6F0]/55">
          En cumplimiento de la Ley Federal de Protección de Datos Personales en
          Posesión de los Particulares (LFPDPPP) — Última actualización:
          febrero 2026
        </p>

        <div className="mt-14">
          <Section title="1. Responsable del tratamiento" testid="privacy-responsible">
            <p>
              <strong className="text-[#F9F6F0] font-semibold">
                EMB Consulting Group
              </strong>{" "}
              (en adelante "la firma"), denominación bajo la cual el suscrito
              Marco S. Equis opera como Promotoría Allianz México No. 559 y
              como intermediario autorizado con clave directa en Skandia y
              Dominion Capital Strategies, con domicilio en Playa del Carmen,
              Quintana Roo, México, es responsable del tratamiento de tus datos
              personales conforme a este aviso de privacidad.
            </p>
            <p>
              Contacto para asuntos de privacidad:{" "}
              <a
                href="mailto:atencion@embconsultingroup.com.mx"
                className="text-[#E6D5B8] hover:underline"
              >
                atencion@embconsultingroup.com.mx
              </a>
              .
            </p>
          </Section>

          <Section title="2. Datos personales que recabamos" testid="privacy-data">
            <p>Para brindarte nuestros servicios podemos recabar:</p>
            <ul className="list-none space-y-2 pl-4">
              <li>
                <span className="text-[#E6D5B8] mr-2">·</span>
                Datos de identificación: nombre completo, fecha de nacimiento,
                nacionalidad, RFC, CURP.
              </li>
              <li>
                <span className="text-[#E6D5B8] mr-2">·</span>
                Datos de contacto: domicilio, teléfono, correo electrónico,
                ciudad de residencia.
              </li>
              <li>
                <span className="text-[#E6D5B8] mr-2">·</span>
                Datos patrimoniales y financieros: ingresos, egresos,
                inversiones actuales, deudas, beneficiarios, objetivos
                financieros (solo cuando el cliente decida contratar servicios
                de asesoría formal con la firma).
              </li>
              <li>
                <span className="text-[#E6D5B8] mr-2">·</span>
                Datos profesionales: ocupación, situación de cédula, experiencia
                (en caso de aplicación al equipo).
              </li>
              <li>
                <span className="text-[#E6D5B8] mr-2">·</span>
                Datos de navegación: dirección IP, tipo de dispositivo y
                navegador, páginas visitadas (vía cookies estrictamente
                necesarias).
              </li>
            </ul>
            <p>
              La firma{" "}
              <strong className="text-[#F9F6F0] font-semibold">
                no recaba datos personales sensibles
              </strong>{" "}
              salvo aquellos estrictamente necesarios para la contratación de
              productos de salud o vida, los cuales serán recabados directamente
              por la institución aseguradora correspondiente conforme a su
              propio aviso de privacidad.
            </p>
          </Section>

          <Section title="3. Finalidades del tratamiento" testid="privacy-purposes">
            <p>
              <strong className="text-[#F9F6F0] font-semibold">
                Finalidades primarias (necesarias para el servicio):
              </strong>
            </p>
            <ul className="list-none space-y-2 pl-4">
              <li>
                <span className="text-[#E6D5B8] mr-2">·</span>Atender solicitudes
                de contacto y asesoría inicial.
              </li>
              <li>
                <span className="text-[#E6D5B8] mr-2">·</span>Diseñar e
                implementar planes financieros y de protección personalizados.
              </li>
              <li>
                <span className="text-[#E6D5B8] mr-2">·</span>Gestionar la
                contratación de productos con instituciones financieras y
                aseguradoras.
              </li>
              <li>
                <span className="text-[#E6D5B8] mr-2">·</span>Dar seguimiento
                post-venta y revisiones periódicas.
              </li>
              <li>
                <span className="text-[#E6D5B8] mr-2">·</span>Cumplir
                obligaciones fiscales, regulatorias y de prevención de lavado
                de dinero.
              </li>
              <li>
                <span className="text-[#E6D5B8] mr-2">·</span>Atender solicitudes
                de aplicación al equipo de asesores.
              </li>
            </ul>
            <p>
              <strong className="text-[#F9F6F0] font-semibold">
                Finalidades secundarias (no necesarias):
              </strong>
            </p>
            <ul className="list-none space-y-2 pl-4">
              <li>
                <span className="text-[#E6D5B8] mr-2">·</span>Envío de
                comunicaciones informativas sobre nuevos productos, análisis e
                insights editoriales.
              </li>
              <li>
                <span className="text-[#E6D5B8] mr-2">·</span>Encuestas de
                satisfacción.
              </li>
            </ul>
            <p>
              Puedes oponerte al tratamiento de tus datos para finalidades
              secundarias en cualquier momento, enviando un correo a{" "}
              <a
                href="mailto:atencion@embconsultingroup.com.mx"
                className="text-[#E6D5B8] hover:underline"
              >
                atencion@embconsultingroup.com.mx
              </a>
              .
            </p>
          </Section>

          <Section title="4. Transferencias de datos" testid="privacy-transfers">
            <p>
              Para poder gestionar la contratación de productos financieros y
              de seguros, transferimos los datos personales estrictamente
              necesarios a las instituciones que el cliente decida contratar
              (incluyendo, según el caso, Allianz México, Skandia, Dominion
              Capital Strategies, HDI, AXA, Qualitas, BUPA, Olé Life, Atlas,
              Bx+, Continental, ANA Seguros), las cuales operan bajo sus
              propios avisos de privacidad y son responsables del tratamiento
              de los datos que reciben.
            </p>
            <p>
              Estas transferencias no requieren consentimiento expreso
              adicional al estar fundadas en una relación contractual prevista
              por el artículo 37 fracción IV de la LFPDPPP.
            </p>
            <p>
              No realizamos venta ni cesión de datos personales a terceros con
              fines comerciales.
            </p>
          </Section>

          <Section title="5. Derechos ARCO" testid="privacy-arco">
            <p>
              Como titular de tus datos personales, tienes en todo momento
              derecho a:{" "}
              <strong className="text-[#F9F6F0] font-semibold">
                Acceder
              </strong>{" "}
              a los datos que poseemos;{" "}
              <strong className="text-[#F9F6F0] font-semibold">
                Rectificar
              </strong>{" "}
              datos inexactos o desactualizados;{" "}
              <strong className="text-[#F9F6F0] font-semibold">Cancelar</strong>{" "}
              su uso cuando consideres que no se requiere para alguna de las
              finalidades aplicables;{" "}
              <strong className="text-[#F9F6F0] font-semibold">Oponerte</strong>{" "}
              a su tratamiento para fines específicos.
            </p>
            <p>
              Para ejercer cualquier derecho ARCO, envía una solicitud a{" "}
              <a
                href="mailto:atencion@embconsultingroup.com.mx"
                className="text-[#E6D5B8] hover:underline"
              >
                atencion@embconsultingroup.com.mx
              </a>{" "}
              indicando: (i) tu nombre completo y medio para recibir respuesta;
              (ii) documentos que acrediten tu identidad; (iii) descripción
              clara del derecho que deseas ejercer y los datos involucrados.
              Daremos respuesta en un plazo no mayor a 20 días hábiles
              conforme al artículo 32 de la LFPDPPP.
            </p>
          </Section>

          <Section title="6. Revocación del consentimiento" testid="privacy-revoke">
            <p>
              Puedes revocar en cualquier momento el consentimiento que nos
              hayas otorgado para el tratamiento de tus datos personales, salvo
              en los casos en que dicho tratamiento sea necesario para cumplir
              obligaciones derivadas de una relación jurídica vigente
              (contratos de seguros, planes de inversión activos, etc.).
            </p>
          </Section>

          <Section title="7. Medidas de seguridad" testid="privacy-security">
            <p>
              Implementamos medidas técnicas, administrativas y físicas
              razonables para proteger los datos personales contra daño,
              pérdida, alteración, destrucción o acceso no autorizado,
              incluyendo conexiones cifradas (HTTPS), almacenamiento en
              servidores con control de acceso y procesos internos de
              confidencialidad para el equipo de asesores.
            </p>
          </Section>

          <Section title="8. Uso de cookies" testid="privacy-cookies">
            <p>
              Este sitio utiliza cookies estrictamente necesarias para su
              funcionamiento (sesión, idioma, accesibilidad) y cookies
              analíticas anónimas para entender el comportamiento general de
              navegación. No utilizamos cookies publicitarias de terceros para
              perfilamiento agresivo.
            </p>
          </Section>

          <Section title="9. Cambios al aviso" testid="privacy-changes">
            <p>
              Nos reservamos el derecho de actualizar este aviso de privacidad.
              Cualquier modificación será publicada en este mismo sitio con la
              fecha de su última actualización. Te recomendamos consultar esta
              página periódicamente.
            </p>
          </Section>

          <Section title="10. Autoridad de protección" testid="privacy-authority">
            <p>
              Si consideras que tu derecho a la protección de datos personales
              ha sido vulnerado, puedes acudir al{" "}
              <strong className="text-[#F9F6F0] font-semibold">
                Instituto Nacional de Transparencia, Acceso a la Información y
                Protección de Datos Personales (INAI)
              </strong>{" "}
              en{" "}
              <a
                href="https://home.inai.org.mx"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#E6D5B8] hover:underline"
              >
                home.inai.org.mx
              </a>
              .
            </p>
          </Section>

          <div className="mt-16 pt-8 border-t border-white/10 text-xs text-[#A397B4]/80 leading-relaxed">
            Este aviso de privacidad es un borrador base alineado a los
            requisitos de la LFPDPPP y su reglamento. Debe ser revisado y
            validado por el área legal del cliente antes de su uso definitivo.
          </div>
        </div>
      </article>
    </PageShell>
  );
};

export default Privacidad;
